import { BuiltCategory, BuiltSubcategory } from "@/graphql"

export const builtCategoryValues = [
	BuiltCategory.Multiresidential,
	BuiltCategory.MixedUse,
	BuiltCategory.Commercial,
	BuiltCategory.Industrial,
	BuiltCategory.Agricultural,
	BuiltCategory.Institutional,
	BuiltCategory.Recreational,
	BuiltCategory.Other,
]

const builtSubcategoryBucketByValue: Record<BuiltSubcategory, string> = {
	[BuiltSubcategory.SingleFamilyRental]: "BUILT_MRES_SFR",
	[BuiltSubcategory.Plex_2_6]: "BUILT_MRES_PLEX_2_6",
	[BuiltSubcategory.LowRise]: "BUILT_MRES_LOWRISE",
	[BuiltSubcategory.MidRise]: "BUILT_MRES_MIDRISE",
	[BuiltSubcategory.HighRise]: "BUILT_MRES_HIGHRISE",
	[BuiltSubcategory.StudentHousing]: "BUILT_MRES_STUDENT",
	[BuiltSubcategory.SeniorsHousing]: "BUILT_MRES_SENIORS",
	[BuiltSubcategory.MultiresidentialOther]: "BUILT_MRES_OTHER",
	[BuiltSubcategory.ResidentialCommercial]: "BUILT_MIX_RES_COM",
	[BuiltSubcategory.CommercialOffice]: "BUILT_MIX_COM_OFFICE",
	[BuiltSubcategory.MixedUseOther]: "BUILT_MIX_OTHER",
	[BuiltSubcategory.Retail]: "BUILT_COM_RETAIL",
	[BuiltSubcategory.Office]: "BUILT_COM_OFFICE",
	[BuiltSubcategory.HotelMotel]: "BUILT_COM_HOTEL",
	[BuiltSubcategory.CommercialOther]: "BUILT_COM_OTHER",
	[BuiltSubcategory.LightManufacturing]: "BUILT_IND_LIGHTMFG",
	[BuiltSubcategory.HeavyManufacturing]: "BUILT_IND_HEAVYMFG",
	[BuiltSubcategory.WarehouseDistribution]: "BUILT_IND_WAREHOUSE",
	[BuiltSubcategory.FlexIndustrial]: "BUILT_IND_FLEX",
	[BuiltSubcategory.IndustrialCondo]: "BUILT_IND_CONDO",
	[BuiltSubcategory.SelfStorage]: "BUILT_IND_SELFSTORAGE",
	[BuiltSubcategory.ColdStorage]: "BUILT_IND_COLDSTORAGE",
	[BuiltSubcategory.DataCenter]: "BUILT_IND_DATACENTER",
	[BuiltSubcategory.Automotive]: "BUILT_IND_AUTOMOTIVE",
	[BuiltSubcategory.IndustrialOther]: "BUILT_IND_OTHER",
}

const builtSubcategoriesByCategory: Record<BuiltCategory, BuiltSubcategory[]> = {
	[BuiltCategory.Multiresidential]: [
		BuiltSubcategory.SingleFamilyRental,
		BuiltSubcategory.Plex_2_6,
		BuiltSubcategory.LowRise,
		BuiltSubcategory.MidRise,
		BuiltSubcategory.HighRise,
		BuiltSubcategory.StudentHousing,
		BuiltSubcategory.SeniorsHousing,
		BuiltSubcategory.MultiresidentialOther,
	],
	[BuiltCategory.MixedUse]: [
		BuiltSubcategory.ResidentialCommercial,
		BuiltSubcategory.CommercialOffice,
		BuiltSubcategory.MixedUseOther,
	],
	[BuiltCategory.Commercial]: [
		BuiltSubcategory.Retail,
		BuiltSubcategory.Office,
		BuiltSubcategory.HotelMotel,
		BuiltSubcategory.CommercialOther,
	],
	[BuiltCategory.Industrial]: [
		BuiltSubcategory.LightManufacturing,
		BuiltSubcategory.HeavyManufacturing,
		BuiltSubcategory.WarehouseDistribution,
		BuiltSubcategory.FlexIndustrial,
		BuiltSubcategory.IndustrialCondo,
		BuiltSubcategory.SelfStorage,
		BuiltSubcategory.ColdStorage,
		BuiltSubcategory.DataCenter,
		BuiltSubcategory.Automotive,
		BuiltSubcategory.IndustrialOther,
	],
	[BuiltCategory.Agricultural]: [],
	[BuiltCategory.Institutional]: [],
	[BuiltCategory.Recreational]: [],
	[BuiltCategory.Other]: [],
}

const builtAssetBucketsByCategory: Record<BuiltCategory, string[]> = {
	[BuiltCategory.Multiresidential]: builtSubcategoryBuckets(
		builtSubcategoriesByCategory[BuiltCategory.Multiresidential]
	),
	[BuiltCategory.MixedUse]: builtSubcategoryBuckets(builtSubcategoriesByCategory[BuiltCategory.MixedUse]),
	[BuiltCategory.Commercial]: builtSubcategoryBuckets(builtSubcategoriesByCategory[BuiltCategory.Commercial]),
	[BuiltCategory.Industrial]: builtSubcategoryBuckets(builtSubcategoriesByCategory[BuiltCategory.Industrial]),
	[BuiltCategory.Agricultural]: ["BUILT_AGR"],
	[BuiltCategory.Institutional]: ["BUILT_INST"],
	[BuiltCategory.Recreational]: ["BUILT_REC"],
	[BuiltCategory.Other]: ["BUILT_OTHER"],
}

export function builtAssetBuckets(categories: string[]): string[] {
	return categories.flatMap(category => builtAssetBucketsByCategory[category as BuiltCategory] ?? [])
}

export function builtSubcategories(categories: string[]): BuiltSubcategory[] {
	return categories.flatMap(category => builtSubcategoriesByCategory[category as BuiltCategory] ?? [])
}

export function builtSubcategoryBuckets(subcategories: string[]): string[] {
	return subcategories.flatMap(subcategory => builtSubcategoryBucketByValue[subcategory as BuiltSubcategory] ?? [])
}
